// @flow
import { TiposActionTypes } from './constants';

type TiposAction = { type: string, payload: {} | string };

// common success
export const tiposNoticiaApiResponseSuccess = (actionType: string, data: any): TiposAction => ({
    type: TiposActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const tiposNoticiaApiResponseError = (actionType: string, error: string): TiposAction => ({
    type: TiposActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getTipoNoticia = (id: string): TiposAction => ({
    type: TiposActionTypes.GET_TIPO,
    payload: { id },
});

export const addTipoNoticia = (tipo:any):TiposAction=>({
    type:TiposActionTypes.ADD_TIPO,
    payload:tipo
})
export const updateTipoNoticia = (tipo:any):TiposAction=>({
    type:TiposActionTypes.UPDATE_TIPO,
    payload:tipo
})
export const deleteTipoNoticia = (id:string):TiposAction=>({
    type:TiposActionTypes.DELETE_TIPO,
    payload:{id}
})

export const listTiposNoticia = (params:any): TiposAction => ({
    type: TiposActionTypes.LIST_TIPOS,
    payload: params,
});


export const resetTiposNoticia = (): TiposAction => ({
    type: TiposActionTypes.RESET,
    payload: {},
});

